module.exports = __webpack_public_path__ + "img/p7-box.c27452e4.png";